<template>
  <div class="mini-cart-footer">
    <base-link :href="url" variant="primary-button">{{ text }}</base-link>
  </div>
</template>

<script>
import BaseLink from '@/components/base/base-link'
import { lsGet } from '@/utils/localStorageController'
import { localStorageKeys } from '@/config/constants'

export default {
  name: 'mini-cart-footer',
  components: { BaseLink },
  props: {
    cartIsEmpty: {
      type: Boolean,
      default: true
    },
    cartData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    text () {
      return !this.$props.cartIsEmpty ? this.$t('miniCart.listOfDevices') : this.$t('miniCart.continueOrder')
    },
    url () {
      const items = this.cartData.entries || []
      const onlyTariffsInCart = items.length > 0 && items.every(item => item.productOfferingType === 'TARIFF')

      if (onlyTariffsInCart && lsGet(localStorageKeys.touristCO)) return this.URL.purchase + lsGet(localStorageKeys.touristCO)
      else return !this.$props.cartIsEmpty ? this.URL.private.PLP.mobile : this.URL.purchase
    }
  }
}
</script>

<style lang="scss" scoped>
.mini-cart-footer {
  border-top: .1rem solid $border-color;
  padding: 1.6rem 2.4rem;

  a {
    width: 100%;

    &:hover {
      color: $white;
    }
  }
}
</style>
